import { LoginView } from "../views/loginView.jsx";
import { signInUser} from "../util/firestoreModel.js";
import { useState } from "react";

function Login() {
    const [loading, setLoading] = useState(false);

  function handleSignupACB() {
    window.location.hash = "#/signup";
  }

  function forgotpasswordACB() {
    window.location.hash = "#/forgotpassword";
  }

  async function handleLoginACB(email, password) {
     setLoading(true);
    try {
      await signInUser(email, password);
      window.location.hash = "#/mapOverview";
    } catch (error) {
      console.error("Login error:", error);
      alert(error.message);
    }finally {
      setLoading(false);
    }
  }

  return (
    <LoginView
      onLogin={handleLoginACB}
      onSignUp={handleSignupACB}
      onForgot={forgotpasswordACB}
       loading={loading}
    />
  );
}

export { Login };
